import React from 'react';
import { useParams } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import AppTestsPage from '../../features/apps/components/AppTestsPage';

const AppTestsRoute = () => {
  const { id } = useParams();
  
  return (
    <ProtectedRoute>
      <AppTestsPage appId={id} />
    </ProtectedRoute>
  );
};

export default AppTestsRoute;
